module.exports = __webpack_public_path__ + "static/media/page-header-m.81d32088.jpg";